import { call, put, takeEvery } from 'redux-saga/effects';

import Actions from '../action';
import Axios from 'axios';
import { message } from 'antd';
import { API_DOMAIN } from '@constants/app-constants';

export function* sendMailServiceWorker({ email, history }) {
	try {
		const companyId = localStorage.getItem('companyId');
		const url = `${API_DOMAIN}/DocumentSign/${companyId}/SendMail`;
		const res = yield call(Axios.post, url, { emailId: email });
		yield put(Actions.creators.sendEmailSuccess(res));
		message.success('Email send successfully.');
		history.push('/user/signature/4');
	} catch (e) {
		message.error('Network error.');
		history.push('/user/signature/4');
		yield put(Actions.creators.sendEmailError());
	}
}

export default function* companyInfosWatcher() {
	yield takeEvery(Actions.types.SEND_EMAIL_START, sendMailServiceWorker);
}
